'use strict';

angular.module('app.insightReportOpportunity', [])
    .directive('insightReportOpportunityDirective', function () {
        return {
            controller: 'insightReportOpportunityCtrl',
            templateUrl: 'app/measure/insightReport/insightReportOpportunity/insightReportOpportunity.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })